import { SellerProfession } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/seller_profession';
import { ProfessionBIExtensionData } from '../../types';
import { PAGE_NAME } from '../consts';
import { ClickEventPropsBase, ImpEventPropsBase, reportClickBase, reportImpressionBase } from './base';

const getProfessionExtensionParams = (professionExtension: ProfessionBIExtensionData) => ({
    profession: professionExtension.profession || undefined,
    variant: professionExtension.variant || undefined,
    computedTitle: professionExtension.computedTitle || undefined,
});

interface ReportClickProfessionsProps extends ClickEventPropsBase {
    professionExtension: ProfessionBIExtensionData;
}

export const reportProfessionsClick = ({ professionExtension, ...props }: ReportClickProfessionsProps) => {
    reportClickBase<SellerProfession>({
        ...props,
        additionalData: {
            type: SellerProfession,
            message: {
                pageName: PAGE_NAME,
                ...getProfessionExtensionParams(professionExtension),
            },
        },
    });
};

interface ReportImpProfessionsProps extends ImpEventPropsBase {
    professionExtension: ProfessionBIExtensionData;
}

export const reportProfessionsImpression = ({ professionExtension, ...props }: ReportImpProfessionsProps) => {
    reportImpressionBase<SellerProfession>({
        ...props,
        additionalData: {
            type: SellerProfession,
            message: {
                pageName: PAGE_NAME,
                ...getProfessionExtensionParams(professionExtension),
            },
        },
    });
};
